import React from 'react';
import styled from 'styled-components';
import { Box } from '../../../../../../CommonComponents/OPL/Box/Box';
import { Text } from '../../../../../../CommonComponents/OPL/Text/Text';
import { Icon } from '../../../../../../CommonComponents/OPL/Icon/Icon';
import { Tooltip } from '../../../../../../CommonComponents/OPL/Tooltip/Tooltip';

const ListTitle = styled(Text).attrs({
  fontSize: 'small',
  fontWeight: 500,
  color: 'neutral.100',
})``;

const ListItem = styled(Text).attrs({
  fontSize: 'small',
  color: 'neutral.100',
})``;

const TooltipContent = () => {
  return (
    <Box display="flex" flexDirection="column" css="gap: 4px">
      <Text fontSize="small" fontWeight={600} color="neutral.100">
        Cost Estimates
      </Text>

      <ListTitle>Prior to 65:</ListTitle>
      <Box as="ul" pl="24">
        <ListItem as="li">Private insurance</ListItem>
        <ListItem as="li">Additional out of pocket expenses</ListItem>
      </Box>

      <ListTitle>65 and older:</ListTitle>
      <Box as="ul" pl="24">
        <ListItem as="li">Medicare part B &amp; D</ListItem>
        <ListItem as="li">Medigap</ListItem>
        <ListItem as="li">Additional Out of Pocket Expenses</ListItem>
      </Box>
    </Box>
  );
};

export const EstimateExpensesTooltip = () => {
  return (
    <Tooltip content={<TooltipContent />} placement="right">
      <Icon className="far fa-info-circle" color="neutral.500" ml="4" />
    </Tooltip>
  );
};
